import {FetchStatus, ISticker, IStickersState} from "./reducer";

export const stickersStateSelector = (state: any): IStickersState => state.stickers.entities.stickers;

export const stickerSelector = (state: any, stickerId: string): ISticker | null => {
    const stickersState = stickersStateSelector(state);
    return stickersState.byId[stickerId];
};

export const stickerFetchStatusSelector = (state: any, stickerId: string): FetchStatus => {
    const stickersState = stickersStateSelector(state);
    return stickersState.fetchState[stickerId]?.status || 'idle';
};



// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/entities/stickers/selectors.ts